import { project03Images } from './assets';

const comparisonContent = [
  {
    id: 'comparison-01',
    title: 'Фасад 1',
    description:
      'Сравнение показывает, как проёмы, высотные отметки и архитектурные детали перенесены из облака точек в согласованный обмерный чертёж.',
  },
  {
    id: 'comparison-02',
    title: 'Фасад 2',
    description:
      'Во втором фасаде сохранены фактическая наружная геометрия и характерные архитектурные особенности существующего здания церкви.',
  },
  {
    id: 'comparison-03',
    title: 'План этажа',
    description:
      'На плане зафиксированы фактическая геометрия стен, проёмы, колонны и размерные связи, определённые по данным сканирования.',
  },
  {
    id: 'comparison-04',
    title: 'Разрез A',
    description:
      'Продольный разрез отражает вертикальную геометрию, уровни перекрытий, башню, форму кровли и основные внутренние связи.',
  },
  {
    id: 'comparison-05',
    title: 'Разрез B',
    description:
      'Поперечный разрез сохраняет измеренные отметки, профиль здания, геометрию кровли и видимые элементы интерьера.',
  },
];

const comparisonItems = project03Images.comparisons.map((images, index) => ({
  id: images.id,
  ...(comparisonContent[index] || {}),
  source: images.source,
  result: images.result,
}));

const resultContent = [
  [
    'result-01',
    'План этажа',
    'Обмерный план этажа с фактической геометрией стен, проёмов, колонн, размерами и основными связями.',
  ],
  [
    'result-02',
    'План верхнего уровня',
    'Обмерный план верхнего уровня с геометрией стен, проёмов, колонн, размерами и основными связями.',
  ],
  [
    'result-03',
    'План кровли',
    'Обмерный план кровли с фактическими контурами, уклонами, пересечениями, размерами и основными связями.',
  ],
  [
    'result-04',
    'Геометрия кровли',
    'Обмерный чертёж кровли с фактическими контурами, пересечениями, размерами и основными связями.',
  ],
  [
    'result-05',
    'Фасад 1',
    'Боковой фасад, построенный по облаку точек: проёмы, геометрия башни, профили кровли и наружные архитектурные детали.',
  ],
  [
    'result-06',
    'Фасады 2 и 4',
    'Два согласованных торцевых фасада с существующими проёмами, башней, конфигурацией кровли, отметками и наружной геометрией.',
  ],
  [
    'result-07',
    'Фасад 3',
    'Боковой фасад с измеренными отметками, проёмами, башней, геометрией кровли и характерными архитектурными деталями.',
  ],
  [
    'result-08',
    'Разрез A',
    'Продольный разрез здания по данным сканирования: вертикальная геометрия, уровни, конструкция кровли и основные внутренние связи.',
  ],
  [
    'result-09',
    'Разрезы B и C',
    'Поперечные разрезы с измеренными отметками, конфигурацией кровли, башней и основной внутренней геометрией здания.',
  ],
];

const resultItems = project03Images.results.map((images, index) => {
  const content = resultContent[index];

  return {
    ...images,
    ...(content ? {
      title: content[1],
      description: content[2],
    } : {}),
  };
});

const project03 = {
  id: '3',
  slug: 'project-03',
  template: 'project-01',
  images: {
    catalog: project03Images.catalog,
    hero: project03Images.hero,
  },
  type: { id: '2d-documentation', label: '2D-документация' },
  catalog: {
    index: '03',
    title: '2D-документация церкви',
    description:
      'Обмерная 2D-документация существующей церкви по облаку точек для дальнейшего проектирования, анализа и реставрации.',
    tags: ['2D CAD', 'Облако точек', 'Обмерные чертежи'],
    skills: '2D-документация, облако точек, обмерные чертежи',
    image: project03Images.catalog,
    ctaLabel: 'Смотреть кейс',
  },
  hero: {
    backLabel: 'Назад к проектам',
    title: '2D-документация церкви по облаку точек',
    titleLines: ['2D-документация церкви', 'по облаку точек'],
    description:
      'По облаку точек существующей церкви подготовлен подробный комплект обмерных 2D-чертежей для дальнейшего проектирования, анализа и реставрационных работ.',
    descriptionLines: [
      'По облаку точек существующей церкви подготовлен подробный комплект обмерных 2D-чертежей',
      'для дальнейшего проектирования, анализа и реставрационных работ.',
    ],
    image: project03Images.hero,
    stats: [
      { id: 'service', value: 'Облако точек → 2D', label: 'Услуга' },
      { id: 'source', value: 'Облако точек', label: 'Исходные данные' },
      { id: 'output', value: 'DWG / PDF', label: 'Формат выдачи' },
    ],
  },
  visual: {
    ...project03Images.hero,
    ariaLabel: 'Визуализация проекта',
  },
  info: {
    ariaLabel: 'Краткая информация о проекте',
    equalHeight: true,
    items: [
      {
        id: 'client',
        label: 'Тип здания',
        value: 'Церковь',
      },
      { id: 'stage', label: 'Этап', value: 'Подготовка к реставрации' },
      {
        id: 'workPurpose',
        label: 'Назначение работ',
        value: 'Обмерная документация',
      },
      { id: 'year', label: 'Век постройки', value: 'XIX век' },
    ],
  },
  introAccordion: {
    aboutTitle: 'О проекте',
    aboutHint: 'Контекст, выполненные работы и итоговый результат',
    sourceDataTitle: 'Исходные данные и требования',
    sourceDataHint: 'Материалы обследования, охват и требования к 2D-документации',
    tasksTitle: 'Задача проекта',
    tasksHint: 'Основные требования к комплекту обмерных чертежей',
    processTitle: 'Процесс работы',
    processHint: 'Три этапа подготовки и выдачи документации',
    collapseLabel: 'Свернуть',
  },
  about: {
    title: 'О проекте',
    bodyOnly: true,
    paragraphs: [
      'По предоставленному облаку точек существующей церкви требовалось подготовить подробный комплект обмерных 2D-чертежей. Документация фиксирует геометрию здания и основные архитектурные элементы для дальнейшего проектирования, анализа и реставрационных работ.',
      'Облако точек использовалось как основной геометрический источник для всего комплекта. Планы, фасады, разрезы и геометрия кровли построены по данным сканирования с сохранением фактических неровностей и архитектурных особенностей существующего здания.',
      'В результате сформирована согласованная модель фактического состояния церкви, которая наглядно описывает общую геометрию, отметки, проёмы, конфигурацию кровли и основные архитектурные элементы.',
    ],
  },
  sourceData: {
    title: 'Исходные данные',
    items: [
      { id: 'format', label: 'Формат облака точек', value: 'RCP / E57' },
      {
        id: 'additionalMaterials',
        label: 'Дополнительные материалы',
        value: 'Фотофиксация объекта',
      },
      {
        id: 'coverage',
        label: 'Охват',
        value: 'Здание, фасады, кровля и интерьер',
      },
      {
        id: 'result',
        label: 'Требуемый результат',
        value: 'Комплект обмерных чертежей в DWG',
      },
    ],
    capturedTitle: 'Что было зафиксировано',
    capturedItems: [
      {
        id: 'structure',
        label: 'Фактическая геометрия стен, колонн и проёмов',
      },
      {
        id: 'ceiling',
        label: 'Высотные отметки и вертикальные связи здания',
      },
      {
        id: 'roof',
        label: 'Контуры, уклоны и основные пересечения кровли',
      },
      {
        id: 'facades',
        label: 'Фасады, наружные проёмы и архитектурные детали',
      },
      {
        id: 'equipment',
        label: 'Башня и характерные архитектурные элементы здания',
      },
      {
        id: 'site',
        label: 'Внутренняя геометрия для подготовки разрезов',
      },
    ],
  },
  tasks: {
    title: 'Задача проекта',
    items: [
      'Подготовить по облаку точек согласованные планы, фасады, разрезы и чертежи кровли.',
      'Сохранить измеренные неровности и архитектурные особенности существующего здания церкви.',
      'Зафиксировать видимые проёмы, высотные отметки, конфигурацию кровли и основные архитектурные элементы.',
      'Обеспечить единообразие геометрии, размеров и графического оформления всего комплекта чертежей.',
    ],
  },
  process: {
    title: 'Процесс работы',
    items: [
      {
        id: '01',
        title: 'Подготовка исходных данных',
        text: 'Проверили покрытие облака точек, сопоставили его с материалами обследования и подготовили рабочие сечения для построения чертежей.',
      },
      {
        id: '02',
        title: 'Создание 2D-документации',
        text: 'Перенесли фактическую геометрию церкви, кровли, фасадов и интерьеров в структурированный комплект DWG-чертежей.',
      },
      {
        id: '03',
        title: 'Контроль и выдача',
        text: 'Сверили взаимное соответствие планов, фасадов и разрезов, проверили ключевые отметки и подготовили комплект к выдаче.',
      },
    ],
  },
  comparisonGallery: {
    title: 'От облака точек к 2D-документации',
    description:
      'Облако точек стало основным геометрическим источником для всего комплекта. Планы, фасады, разрезы и геометрия кровли построены по данным сканирования с сохранением фактических неровностей и архитектурных особенностей здания.',
    sourceLabel: 'Облако точек',
    resultLabel: '2D-документация',
    modalLabel: 'Просмотр сравнения облака точек и 2D-документации',
    backLabel: 'Назад к сравнению',
    previousLabel: 'Назад',
    nextLabel: 'Далее',
    closeLabel: 'Закрыть просмотр',
    loadingLabel: 'Загрузка изображения…',
    items: comparisonItems,
  },
  resultGallery: {
    title: 'Итоговая 2D-документация',
    description:
      'Итоговый комплект представляет согласованное описание существующего здания церкви и наглядно отражает его общую геометрию, отметки, проёмы, конфигурацию кровли и основные архитектурные элементы.',
    modalLabel: 'Просмотр итоговой 2D-документации',
    previousLabel: 'Назад',
    nextLabel: 'Далее',
    closeLabel: 'Закрыть просмотр',
    loadingLabel: 'Загрузка изображения…',
    errorLabel: 'Не удалось загрузить изображение',
    zoomLabel: 'Масштаб изображения',
    zoomOutLabel: 'Уменьшить масштаб',
    resetZoomLabel: 'Сбросить масштаб',
    zoomInLabel: 'Увеличить масштаб',
    openImageLabel: 'Открыть изображение',
    ofLabel: 'из',
    modalEnabled: true,
    // The 3x full-size exports lose one-pixel dimension lines when fitted to the modal.
    // These previews were downsampled specifically to preserve the drawing line weight.
    modalImageVariant: 'preview',
    zoomEnabled: true,
    addGridSpacing: true,
    carouselEnabled: true,
    items: resultItems,
  },
  deliverables: {
    title: 'Что получил клиент',
    items: [
      'Согласованный комплект обмерных 2D-чертежей существующего здания церкви',
      'Планы этажей, фасады, разрезы и документация по кровле',
      'Редактируемые DWG-файлы и оформленные листы в PDF',
    ],
  },
  benefits: {
    title: 'Что это дало',
    items: [
      'Надёжную геометрическую основу для дальнейшего проектирования и реставрации',
      'Согласованность планов, фасадов, разрезов, отметок и размеров',
      'Доступную фиксацию существующих архитектурных особенностей здания',
    ],
  },
  metrics: {
    title: 'Параметры проекта',
    equalHeight: true,
    items: [
      { id: 'area', label: 'Площадь здания', value: '530 м²' },
      { id: 'volume', label: 'Объём данных (облако точек)', value: '20 ГБ' },
      { id: 'timeline', label: 'Срок выполнения', value: '1 месяц' },
      { id: 'format', label: 'Формат', value: 'DWG / PDF' },
    ],
  },
  estimateCta: {
    eyebrow: 'Оценка по вашим данным',
    title: ['Нужно превратить облако точек', 'в согласованные 2D-чертежи?'],
    text: 'Пришлите фрагмент облака точек или техническое задание. Мы оценим состав чертежей, уровень детализации, сроки и подходящий формат выдачи.',
    buttonLabel: 'Получить оценку проекта',
    href: '/contacts',
    image: project03Images.catalog,
  },
  seo: {
    title: '2D-документация церкви по облаку точек | DotPolyline',
    description:
      'Кейс подготовки согласованного комплекта обмерных планов, фасадов, разрезов и чертежей кровли церкви по облаку точек.',
  },
  scrollToggleLabels: {
    scrollUp: 'Прокрутить вверх',
    scrollDown: 'Прокрутить вниз',
    topTitle: 'Наверх',
    formTitle: 'К низу страницы',
  },
};

export default project03;
